var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShortstrangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 35H49",
    stroke: "#E6E6E6",
    strokeLinecap: "round",
    strokeDasharray: "4 5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0002 43L9.89061 43.6957L14.7932 44H15.1238L15.2533 43.6957L19.0797 34.6996L19.0814 34.6957L24.8278 21.5H30.5035L35.5331 34.6783L35.6559 35H36.0002H40.2619H40.9989L40.7265 34.3152L33.9648 17.3152L33.8394 17H33.5002H21.5002H21.168L21.0393 17.3063L13.896 34.3032L13.8947 34.3063L11.6704 39.5L11.5002 40L11.0002 41L10.0002 43Z",
    fill: "#12B16E",
    stroke: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7 12.5V53.5",
    stroke: "#E6E6E6",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8263 44H39.4956L39.3662 43.6957L35.5381 34.6957L35.2422 34H35.9982H40.2638H40.5936L40.7234 34.3032L43.5 40.5L44.5 42.5L45 43.5L39.8263 44Z",
    fill: "#E94C69",
    stroke: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8545 44.1957L15 44L15.5 43L18.8174 35.1957L19.1133 34.5H18.3573H14.0917H13.7619L13.6321 34.8032L11.4064 40L11 41L10 43.5L14.8545 44.1957Z",
    fill: "#E94C69",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShortstrangle);
export default __webpack_public_path__ + "static/media/short strangle.e81f32c0e551bbdd079290c10db34b1b.svg";
export { ForwardRef as ReactComponent };